export default {
  app: {
    login: 'Logg inn',
    logout: 'Logg ut',
    loggingIn: 'Logger inn',
    withoutFeide: 'Uten feide',
    skipToContent: 'Hopp til hovedinnhold',
    back: 'Tilbake',
  },
  login: {
    title: 'Logg inn i Aschehoug VGS',
    message: 'Du er logget ut. Vennligst logg inn.'
  },
  home: {
    title: 'Hjem',
    welcome: 'Velkommen til Aschehoug VGS',
    subjectTitle: 'Fag'
  },
  footer: {
    uu: 'Universell utforming',
    service: 'Kundeservice',
    privacy: 'Personvern',
    store: 'Nettbutikk',
    copyrights: 'Rettigheter til innhold',
    feedback: 'Gi tilbakemelding',
  },
  resourceGuide: {
    what: 'Hva?',
    how: 'Hvordan?',
    why: 'Hvorfor?',
  },
  topicGuide: {
    justification: 'Begrunnelse',
    preparations: 'Forberedelser',
    differentiation: 'Differensiering',
    evaluation: 'Vurdering',
    execution: 'Gjennomføring',
  },
  topicPage: {
    taskText: 'Oppgaver og aktiviteter',
    teacherContent: {
      title: 'Finn flere ressurser',
      text: 'Som lærer har du tilgang til flere oppgaver og aktiviteter som du kan dele med elevene fra egen enhet.',
      exploreContent: 'Utforsk innhold'
    }
  },
  teacherResourceBank: {
    resource: 'Ressursbank',
    summary: 'Her finner du en oversikt over oppgaver og aktiviteter som kan brukes i arbeidet med dette temaet.'
  },
  subject: {
    title: 'Fagside',
    'subject-resource': 'Fagressurser',
    'to-teacher': 'Til lærer',
    'to-teacher-subject': 'Om læremiddelet',
  },
  'subject-article': {
    'guide-button': 'Lærerveiledning',
    'goal-button': 'Kompetansemål'
  },
  callouts: {
    'not-found-sub-elements': 'Faget har ingen underelementer'
  },
  expandBlock: {
    examples: 'Eksempler',
    'action-text': 'Se løsningsforslag'
  },
  language: {
    nb: 'Bokmål',
    nn: 'Nynorsk'
  },
  settings: {
    title: 'Innstillinger',
    language: 'Målform'
  },
  notFound: {
    title: 'Beklager, vi kunne ikke finne siden.',
    text: 'Siden kan være flyttet eller slettet, eller det kan være en feil i lenken.',
    link: 'Gå til forsiden'
  },
  imageCredits: 'Bilderettigheter',
  navigateTo: 'Naviger til',
  authors: 'Skrevet av',
  loadingContent: 'Laster innhold',
  comingSoon: 'Kommer snart',
  loginWithFeide: 'Logg inn',
  download: {
    urge: 'Last ned "{file}"',
    failed: 'Noe gikk galt ved nedlastingen av filen',
  },
  introduction: 'Introduksjon',
  preparation: 'Forberedelse',
  mimeType: {
    pdf: 'PDF',
    word: 'Word',
    excel: 'Regneark',
    video: 'Video',
    audio: 'Lydfil',
    image: 'Bilde',
    powerpoint: 'Presentasjon',
    archive: 'Arkiv',
    file: 'Fil',
  },
  task: {
    stepTitle: 'Steg',
    taskTitle: 'Oppgave',
    needHelp: 'Trenger du hjelp?',
  },
  assignments: {
    noAssignments: 'Ingen oppgaver er lagt til',
    noPictures: 'Ingen bilder er lagt til',
  },
  credits: 'Kreditering',
  explanation: 'Forklaring',
  welcomeMessage: {
    getToKnow: 'Bli kjent med Modus',
    trySubjects: 'Prøv smakebiter av de første fagene våre. Vi legger til innhold i disse fortløpende. Snart kommer det også innhold fra flere fag.'
  },
  audioPlayer: {
    listenToTheText: 'Lytt til teksten',
    pauseAudio: 'Pause lyd',
    playAudio: 'Spill av lyd',
    close: 'Lukk'
  },
  pageXofY: 'Side {x} av {y}',
  frontPage: {
    digitalTeachingAid: 'Et digitalt læremiddel for videregående skole fra Aschehoug'
  },
  subjectPage: {
    subject: 'Tema'
  },
  uuPage: {
    title: 'Universell utforming i Modus fra Aschehoug',
    welcome: 'Velkommen til vårt digitale læremiddel for videregående skoler, Modus. Vi utvikler universelt utformede læremidler med lærer og elev i fokus.',
    compliance: {
      heading: 'Modus følger alle lovkrav til universell utforming',
      text1: 'Aschehoug skole følger lovkravene i Forskrift om universell utforming av ikt-løsninger, oppfyller de 35 suksesskriteriene i Retningslinjer for tilgjengelig webinnhold (WCAG) 2.0 og oppfyller reglene i EUs webdirektiv (WAD) som trådte i kraft 1. februar 2023. Du kan lese mer om lovkravene på UU tilsynets',
      text2: 'sider',
      text3: 'I Aschehoug skole er vi opptatt av å utvikle digitale læremidler som er gode å bruke for alle elever oglærere. Vi jobber derfor kontinuerlig med universell utforming.'
    },
    accessibilityFeatures: {
      heading: 'Tilgjengelighetsfunksjoner i Modus',
      fontSize: {
        heading: 'Justere skriftstørrelse',
        text: 'Hold ctrl-tasten nede (cmd-tasten på Mac) og trykk samtidig på pluss-tasten for å forstørre teksten, eller trykk på minus-tasten for å forminske teksten.'
      },
      listenToText: {
        heading: 'Lytte til teksten',
        text: 'I Modus kan du lytte til teksten ved hjelp av skjermlesere og innebygget funksjonalitet på PC-er, Mac, iOS og Android.'
      },
      linksAndDocuments: {
        heading: 'Lenker og dokumenter',
        text: 'I Modus markerer vi der hvor lenker åpnes i en ny fane (gjelder eksternt innhold) eller leder til nedlastbare filer.'
      },
      keyboardNavigation: {
        heading: 'Tastaturnavigasjon',
        text1: 'Modus ivaretar personer som ikke kan navigere med mus. Innhold kan navigeres og brukes ved hjelp av tastatur.',
        text2: 'Tab-tasten kan brukes for å hoppe mellom aktive elementer på en side. Hold inne tab-tasten og shift-tasten samtidig for å gå tilbake et steg, og bruk enter-tasten for å aktivere et markert element.',
        text3: 'I noen situasjoner kan piltastene brukes for å interagere med visse typer elementer, som for eksempel å spole gjennom lydklipp og video, endre volum, interagere med enkelte menyer og nedtrekksmenyer.',
        text4: 'Mellomrom-tasten kan brukes til å pause og starte lyd og video.',
        text5: 'Noen typer innhold er unntatt krav til tastaturnavigasjon. På Modus kan dette for eksempel kunne gjelde tegneverktøy. Noen typer oppgaver vil også mangle tastaturnavigasjon, og i de tilfellene er en alternativ oppgave med tastaturnavigasjon tilgjengelig.'
      },
      altText: {
        heading: 'Alternativ bildetekst',
        text: 'I Modus har bilder en alternativ bildetekst som beskriver relevant informasjon i bildet.'
      },
      videoCaptioning: {
        heading: 'Teksting av video',
        text: 'Videoer i Modus er tekstet.'
      },
      supportedDevices: {
        heading: 'Oversikt over støttede enheter',
        text: 'Vi har testet Modus i følgende nettlesere, operativsystemer/enheter og verktøy: Nettlesere:'
      },
      feedback: {
        heading: 'Tilbakemeldinger',
        text1: 'Vi setter stor pris på å få tilbakemeldinger dersom det er ting som ikke fungerer eller kunne vært løst bedre, slik at læremidlene våre blir enda bedre å bruke. Her finner du vår kontaktinformasjon. Lenke til ',
        text2: 'kundeservice'
      }
    }
  },
  contentRightsPage: {
    title: 'Rettigheter til innhold i Modus',
    attentionHeader: 'Vær oppmerksom på dette:',
    contentOwnership: 'Alt innhold i Modus, som tekster, bilder, illustrasjoner, logoer og programkode, tilhører Aschehoug forlag eller våre lisensgivere. Dette innholdet er beskyttet av relevante lover, særlig åndsverkloven og varemerkeloven.',
    usageRestrictions: 'Det er derfor ikke tillatt gjenbruke innholdet ved for eksempel å dele det eller kopiere det inn i andre programmer. Dette gjelder med mindre slik bruk er tillatt etter lov eller gjennom avtale med Kopinor (interesseorgan for rettighetshavere til åndsverk). Dermed er det heller ikke tillatt å mate innhold fra Modus inn i programvare for kunstig intelligens, eller på annen måte bruke det til å utvikle eller bearbeide maskinlæringsalgoritmer.',
    userResponsibility: 'Som bruker er du selv ansvarlig for at innhold du legger inn i Modus eller gjør tilgjengelig for andre gjennom tjenesten, ikke bryter med noens rettigheter.'
  },
  'privacyPage': {
    title: 'Personvern i Modus fra Aschehoug',
    introduction: 'Velkommen til vårt digitale læremiddel Modus. Vi utvikler læremidler med lærer og elev i fokus. På denne siden finner du informasjon om hvordan Aschehoug håndterer elever og læreres personvern i våre tjenester for videregående opplæring.',
    privacyHeader: 'Personvern',
    privacyText1: 'Du kan lese om hvordan vi behandler personopplysninger i vår',
    privacyText2: 'personvernerklæring.',
    agreementsHeader: 'Avtaler med skoleeiere',
    agreementsText: 'Aschehoug har allerede avtaler med de fleste skoleeiere i landet. Ta gjerne kontakt med oss for å få vite om din skoleeier allerede har en slik avtale med oss. Om du ønsker å gjennomlese eller signere databehandleravtale, kontakt',
    subcontractorsHeader: 'Underleverandører',
    subcontractorsText: 'Noen av Aschehougs underleverandører har tilgang til persondata gjennom de tjenestene de leverer til oss. Aschehoug har databehandleravtaler med alle disse. Se oversikt over våre underleverandører.',
    subcontractorsTableHeaders: {
      name: 'Navn på underleverandør',
      serviceType: 'Virksomhetstype/tjeneste som leveres',
      serverLocation: 'Stedlig plassering for serverdrift'
    },
    contactHeader: 'Kontakt',
    contactText: 'Dersom du har spørsmål knyttet til personvern i Modus, ta gjerne kontakt med oss:'
  }
}
